import { useMemo } from 'react'
import { useUserType } from '@labrav/common'
import { useSelector } from '../../../store'
import { CRMTypes } from '../../../utils/constants'

type PartnerData = {
  crmId?: string
  crmType?: string
  subscribedProducts?: {
    FLYOUT?: { plan?: string; cloudProviders?: string[] }
  }
  activeProducts?: string[]
}

export const customerFormData = () => {
  const userType = useUserType()
  const partnerData = useSelector<PartnerData | undefined | null>(
    state => state.AccountData[userType]?.partnerData as PartnerData | undefined
  )

  return useMemo(
    () => ({
      crmType: (partnerData?.crmType as CRMTypes | undefined) || null,
      subscribedProducts: partnerData?.subscribedProducts || {},
    }),
    [partnerData]
  )
}
